import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule } from 'devextreme-angular';
import { HelpTestRoutingModule } from './help.routing.module';
import {  HelpNewComponent } from './help.component';
import { ReactiveFormsModule } from "@angular/forms";
import {
  DxButtonModule,
  DxTextBoxModule,
  DxTreeListModule,
  DxHtmlEditorModule,
  DxTreeViewModule,
  DxSelectBoxModule,
  DxLoadPanelModule,
  DxPopupModule,
  DxScrollViewModule,
  DxFileUploaderModule,
  DxListModule,

} from "devextreme-angular";
import { SharedModule } from "src/app/pipes/shared-module";
@NgModule({
  declarations: [
    HelpNewComponent
  ],
  imports: [
    DxLoadPanelModule,
    ReactiveFormsModule,
    SharedModule,
    DxHtmlEditorModule,
    DxTreeListModule,
    DxTextBoxModule,
    DxButtonModule,
    DxTreeViewModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxFileUploaderModule,
    DxPopupModule,
    CommonModule,
    HelpTestRoutingModule,
    DxDataGridModule,
    DxListModule
  ]
})
export class HelpNewModule { }
export type TreeNode = {
  pageId: any;
  isActive: any;
  key: string;
  parentKey: any;
  text: string;
  id: number;
  isPageId: boolean;
  categoryId:number;
  helpPageId:number;
  name:string;
  parentcategoryId:number;
  isPage:boolean
  FileName:string
  orderBy:number;
   searchWords:string
    IsParentCategoryId:number;
};
export type Tree = {
  key: string;
  parentKey: string;
  text: string;
  id: number;
  isPage?: boolean;
};

export interface HelpSortOrderDto {
  id: number;
  categoryId?: number;
  orderBy: number;
}
export interface HelpSortOrdersDto {
  categories: HelpSortOrderDto[];
  pages: HelpSortOrderDto[];
}

export interface AddHelpCategoryDto {
  categoryId: number;
  parentCategoryId?: number;
  name: string;
  orderBy: number;
  isActive: boolean;
}
export interface HelpPageFileDto {
  fileId: number;
  pageId: number;
  name: string;
  generatedName: string;
  documentUrl: string;
  createdBy: number;
  isDeleted: boolean;
}

export class TreeOrderNodes {
  key: string;
  categoryId:number;
  helpPageId:number;
  level:number;
  orderby:number;
  isActive: boolean;
  parentcategoryId:number;
  IsParentCategoryId:boolean;
};